// Front-end only — no back-end counterpart.

export type ToastType = 'success' | 'error' | 'warning' | 'neutral'

export const ToastType = {
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
  NEUTRAL: 'neutral'
} satisfies Record<string, ToastType>

export const ToastTypeValues: readonly ToastType[] = Object.values(ToastType)
